var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav-container"},[_c('div',{staticClass:"nav-content"},[_c('div',{staticClass:"logo-wrapper"},[_c('a',{staticClass:"logo-link",attrs:{"href":"/"}},[_c('img',{staticClass:"logo-img",attrs:{"src":require("@/assets/img/logo.png"),"alt":"logo"}}),_c('span',{staticClass:"brand-name hidden-xs"},[_vm._v("tnbapp")])])])])])
}]

export { render, staticRenderFns }